import { Button } from '@mui/material';
import { Row, Spacer } from '../../../components';

interface CloseButtonProps {
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const CloseButton: React.FC<CloseButtonProps> = ({ setDrawerOpen }) => {
  return (
    <>
      <Row style={{ justifyContent: 'space-between', marginTop: '45px' }}>
        <Button
          onClick={() => setDrawerOpen(false)}
          className='sm'
          variant='outlined'
          color='secondary'>
          Close
        </Button>
      </Row>
      <Spacer height='md' />
    </>
  );
};

export default CloseButton;
